import { removeItem } from "./alternatePaymentMethodsStorage.js";
import { removeItem as removeItem$1 } from "./requestStorage.js";
import { removeItem as removeItem$2 } from "./responseStorage.js";
const deletionFnFactory = (config, keyProps) => {
  return (payload) => new Promise((resolve) => {
    const { id: paymentMethodIdToDelete } = payload;
    const { accountId } = keyProps;
    removeItem(accountId, paymentMethodIdToDelete);
    removeItem$1(paymentMethodIdToDelete);
    removeItem$2(paymentMethodIdToDelete);
    resolve(void 0);
  });
};
export {
  deletionFnFactory as default
};
//# sourceMappingURL=deletion.js.map
